import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";

const Accordion = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const accordionItems = [
        {
            title: "I dati biometrici del mio gatto sono al sicuro?",
            content: "Assolutamente sì. Il peso e la frequenza di utilizzo rilevati dai sensori della Kleeo vengono trasmessi in modo criptato all'applicazione. Questi dati servono esclusivamente per fornirti il monitoraggio della salute tramite l'App e non vengono condivisi con terze parti."
        },
        {
            title: "Kleeo raccoglie dati audio o video all'interno della mia casa?",
            content: "No. Il modello Kleeo utilizza esclusivamente sensori fisici (celle di carico per il peso e sensori a infrarossi per il movimento). Non è dotata di telecamere o microfoni, garantendo la totale privacy della tua abitazione."
        },
        {
            title: "Come viene gestita la connessione Wi-Fi?",
            content: "La lettiera utilizza il protocollo sicuro dell'ecosistema Tuya Smart. La connessione Wi-Fi serve solo per inviarti notifiche sullo stato della pulizia e aggiornamenti sul benessere del gatto. Puoi disconnettere il dispositivo in qualsiasi momento senza compromettere le funzioni di pulizia automatica."
        },
        {
            title: "Posso cancellare la cronologia delle pesate e delle attività?",
            content: "Certamente. In conformità con il GDPR, puoi eliminare la cronologia delle attività del tuo gatto direttamente dalle impostazioni dell'App o richiedere la cancellazione totale dell'account. Una volta eliminati, i dati non saranno più recuperabili dai nostri sistemi."
        },
        {
            title: "Cosa copre la garanzia di 2 anni?",
            content: "La garanzia copre ogni difetto di fabbricazione delle componenti elettroniche e meccaniche, incluso il motore (certificato per oltre 2000 ore di utilizzo). Sono esclusi i danni derivanti da uso improprio, manomissioni o l'utilizzo di alimentatori non originali."
        },
        {
            title: "Come funziona la prova di 30 giorni 'Soddisfatti o Rimborsati'?",
            content: "Vogliamo che tu e il tuo gatto siate felici. Se entro 30 giorni decidi che Kleeo non fa per voi, puoi richiedere il reso. Il prodotto dovrà essere restituito integro, pulito e nell'imballaggio originale per ricevere il rimborso completo (spese di spedizione escluse)."
        },
        {
            title: "I miei dati di pagamento sono al sicuro?",
            content: "Sì. Tutti i pagamenti sono gestiti tramite gateway criptati sicuri. Kleeo non archivia i dati della tua carta di credito. Inoltre, i dati di navigazione sul sito sono trattati nel pieno rispetto del GDPR per garantirti un'esperienza d'acquisto protetta."
        }
    ];

    return (
        <div className="accordion" id="accordionExample">
            {accordionItems.map((item, index) => (
                <div className="accordion-item" key={index}>
                    <h3 className="accordion-header">
                        <button
                            className={`accordion-button ${activeIndex === index ? "" : "collapsed"}`}
                            onClick={() => toggleAccordion(index)}
                        >
                            {item.title}
                        </button>
                    </h3>
                    <div className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`}>
                        <div className="accordion-body">
                            <p>{item.content}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Accordion;
